const ModalsEnum = {
    SIGN_IN_MODAL: 1,
    SIGN_UP_MODAL: 2,
    RESET_PASSWORD_MODAL: 3,
    CHECK_EMAIL_MODAL: 4,
    CHANGE_PASSWORD_MODAL: 5,
    DELETE_ACCOUNT_MODAL: 6,
    CHECK_EMAIL_SIGNUP_MODAL: 7,
};

export default ModalsEnum;
